/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
import { Checkboxes, Details } from 'nhsuk-react-components';
import { useEffect } from 'react';
import { IterationCohort } from '../../schemas/IterationCohort.schema';
import { SECTIONS } from './Constants';

// eslint-disable-next-line import/prefer-default-export, no-undef
export const CohortsSection: React.FC<{
    cohorts: IterationCohort[];
    checkedItems: Record<string, boolean>;
    sectionChecked: boolean;
    onSectionChange: (id: string) => void;
    handleCheckboxChange: (sectionKey: string, id: string) => void;
}> = ({
  cohorts,
  checkedItems,
  sectionChecked,
  onSectionChange,
  handleCheckboxChange,
}) => {
  const disabled = cohorts?.length === 0;
  const id = SECTIONS.COHORTS;

  const selectedItems = Object.values(checkedItems).filter(Boolean).length;

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    cohorts.map((cohort) => {
      // eslint-disable-next-line no-param-reassign
      checkedItems[cohort.CohortLabel || ''] = false;
    });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Checkboxes.Item
      id={id}
      aria-label={id}
      data-testid={id}
      disabled={disabled}
      checked={sectionChecked}
      onChange={() => onSectionChange('cohorts')}
    >
      <Details>
        <Details.Summary className="nhsuk-u-font-weight-bold">
          Cohorts (
          {selectedItems}
          /
          {cohorts.length}
          {' '}
          selected)
        </Details.Summary>
        {cohorts.length > 0 && (
        <Details.Text className="nhsuk-u-margin-top-5">
          <Checkboxes>
            {cohorts.map((cohort, index) => {
              const cohortId = cohort.CohortLabel || '';
              return (
                <Checkboxes.Item
                  // eslint-disable-next-line react/no-array-index-key
                  key={`${cohortId}-${index}`}
                  id={cohortId}
                  aria-label={cohortId}
                  data-testid={cohortId}
                  checked={
                                            checkedItems[cohortId] || false
                                        }
                  onChange={() => handleCheckboxChange(id, cohortId)}
                >
                  {cohort.CohortLabel}
                </Checkboxes.Item>
              );
            })}
          </Checkboxes>
        </Details.Text>
        )}
      </Details>
    </Checkboxes.Item>
  );
};
